import {Show} from 'components';
import DisplayAndUpdateBillingAddress from 'components/payment/DisplayAndUpdateBillingAddress';
import DisplayAndUpdateDeliveryAddress from 'components/payment/DisplayAndUpdateDeliveryAddress';
import DisplayAndUpdatePaymentCard from 'components/payment/DisplayAndUpdatePaymentCard';
import {H6, P} from 'components/TypographyShortcuts';
import {UserContext} from 'context';
import {useContext} from 'react';
import {EndSection} from '..';
import {bootstrapOldForm} from '../AutoSection';
import {AutoField} from '../fields';
import fields from './fields';
import {useFieldData} from 'components/forms/hooks';
import {Grid} from '@material-ui/core';

const PaymentAndDelivery = ({applicationType}) => {
    const {hasBillingInfo, hasDeliveryInfo, hasPaymentInfo} =
        useContext(UserContext);
    const {initialValues, schema} = bootstrapOldForm('Payment And Delivery', fields);
    const [waivePostDate, setWaivePostDate] = useFieldData(
        'renewal_waive_post_date_checkbox'
    );

    return (
        <EndSection
            buttonText='Create My Perfect Application'
            buttonDisabled={!(hasBillingInfo && hasPaymentInfo && hasDeliveryInfo)}
            endpointOverride={`application/${applicationType}/start`}
            {...{initialValues, schema}}
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <H6>Payment and Delivery</H6>
                    <P>
                        In order to start an application we will need to keep a
                        payment card on file, with correct billing and delivery
                        addresses. If you haven't done so already, please enter a
                        card below. Otherwise, please double check the card info,
                        billing address, and delivery address.
                    </P>
                    <DisplayAndUpdateBillingAddress highlight={!hasBillingInfo} />
                    <Show condition={!hasBillingInfo}>
                        <P color='secondary'>Please enter Billing Address</P>
                    </Show>
                    <DisplayAndUpdatePaymentCard highlight={!hasPaymentInfo} />
                    <Show condition={!hasPaymentInfo}>
                        <P color='secondary'>Please enter a Payment Card</P>
                    </Show>
                    <DisplayAndUpdateDeliveryAddress highlight={!hasDeliveryInfo} />
                    <Show condition={!hasDeliveryInfo}>
                        <P color='secondary'>Please enter a Delivery Address</P>
                    </Show>
                </Grid>
                <Grid item xs={12}>
                    <H6>Renewed MMC issue date</H6>
                    <AutoField
                        field={fields.renewal_waive_post_date_checkbox}
                        name='renewal_waive_post_date_checkbox'
                        onChange={e =>
                            setWaivePostDate(
                                e.currentTarget.value === 'true' ||
                                    e.currentTarget.value === true
                            )
                        }
                    />
                    <Show condition={waivePostDate}>
                        <P color='secondary'>
                            This is only recommended if your employer requires it.
                        </P>
                        <P color='secondary'>
                            If they do not, we recommend clicking NO.{' '}
                        </P>
                        <P color='secondary'>
                            You will still recieve a renewed MMC in the mail but it
                            will not be valid until your current MMC expires.
                        </P>
                    </Show>
                </Grid>
            </Grid>
        </EndSection>
    );
};

export default PaymentAndDelivery;
